// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables() {
  
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_currentAccountV5_marketingProfile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["TeamMarketingProfile"]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"currentAccountV5_marketingProfile_TeamMarketingProfile":{"f":""},"currentAccountV5_marketingProfile":{"u":"response_currentAccountV5_marketingProfile"}}};

let wrapResponseConverterMap = {
  response_currentAccountV5_marketingProfile: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"currentAccountV5_marketingProfile_TeamMarketingProfile":{"f":""},"currentAccountV5_marketingProfile":{"u":"response_currentAccountV5_marketingProfile"}}};

let responseConverterMap = {
  response_currentAccountV5_marketingProfile: unwrap_response_currentAccountV5_marketingProfile
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamMarketingProfileMembersSettingsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "AccountV5",
          "kind": "LinkedField",
          "name": "currentAccountV5",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TeamMarketingProfileMembersSettings_marketingProfile"
                      }
                    ],
                    "type": "TeamMarketingProfile",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "TeamMarketingProfileMembersSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountV5",
        "kind": "LinkedField",
        "name": "currentAccountV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "marketingProfile",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v1/*: any*/),
                    "concreteType": "TeamMarketingProfileMemberConnection",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamMarketingProfileMemberEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MarketingProfileMember",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "id",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfilePhoto",
                                "kind": "LinkedField",
                                "name": "profilePicture",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Variable",
                                        "name": "ratio",
                                        "variableName": "__relay_internal__pv__DevicePixelRatio"
                                      },
                                      {
                                        "kind": "Literal",
                                        "name": "width",
                                        "value": 48
                                      }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v0/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__id",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": "members(first:100)"
                  },
                  {
                    "alias": null,
                    "args": (v1/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "MarketingProfileMembersList_members",
                    "kind": "LinkedHandle",
                    "name": "members"
                  },
                  {
                    "alias": "membersCount",
                    "args": null,
                    "concreteType": "TeamMarketingProfileMemberConnection",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "type": "TeamMarketingProfile",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "610c6be1ef9b31ef713d668f99297d37",
    "id": null,
    "metadata": {},
    "name": "TeamMarketingProfileMembersSettingsQuery",
    "operationKind": "query",
    "text": "query TeamMarketingProfileMembersSettingsQuery(\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  currentAccountV5 {\n    marketingProfile {\n      __typename\n      ... on TeamMarketingProfile {\n        ...TeamMarketingProfileMembersSettings_marketingProfile\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n\nfragment MarketingProfileMembersList_member_marketingProfileMember on MarketingProfileMember {\n  displayName\n  profilePicture {\n    url(width: 48, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  title\n  ...MarketingProfileMembersList_member_menu_marketingProfileMember\n}\n\nfragment MarketingProfileMembersList_member_menu_marketingProfileMember on MarketingProfileMember {\n  id\n  displayName\n  publicUrl\n}\n\nfragment MarketingProfileMembersList_teamMarketingProfile on TeamMarketingProfile {\n  members(first: 100) {\n    edges {\n      node {\n        id\n        ...MarketingProfileMembersList_member_marketingProfileMember\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TeamMarketingProfileMembersSettings_header_marketingProfile on TeamMarketingProfile {\n  membersCount: members {\n    totalCount\n  }\n}\n\nfragment TeamMarketingProfileMembersSettings_marketingProfile on TeamMarketingProfile {\n  ...MarketingProfileMembersList_teamMarketingProfile\n  ...TeamMarketingProfileMembersSettings_header_marketingProfile\n  membersCount: members {\n    totalCount\n  }\n  publicUrl\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_currentAccountV5_marketingProfile = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_currentAccountV5_marketingProfile = unwrap_response_currentAccountV5_marketingProfile;
exports.wrap_response_currentAccountV5_marketingProfile = wrap_response_currentAccountV5_marketingProfile;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
